import { Card, Progress, Stack } from "@mantine/core";

import { Text } from "@/components/ui/elements";

type Props = {
  isForceWithdown: boolean;
  applicationStatus: { currentCount: number; limit: number } | null;
};

// 利用停止状態の応募状況UI
function ForcedWithdrawnContent() {
  return (
    <Stack gap={6} align="center">
      <Text fz="sm" fw="bold" c="gray.7">
        応募状況
      </Text>
      <Text fz="sm" c="gray.6" ta="center">
        ー
      </Text>
      <Text fz="xs" c="dimmed" ta="center" style={{ lineHeight: 1.4 }}>
        現在応募できません
      </Text>
    </Stack>
  );
}

// 通常の応募状況UI
function NormalContent({
  applicationStatus,
}: {
  applicationStatus: { currentCount: number; limit: number } | null;
}) {
  const applicationProgress = applicationStatus?.limit
    ? (applicationStatus.currentCount / applicationStatus.limit) * 100
    : 0;

  const getProgressColor = (progress: number) => {
    if (progress > 80) return "red";
    if (progress > 60) return "orange";
    return "blue";
  };

  return (
    <Stack gap={4}>
      <Stack gap={4}>
        <Text fz="sm" fw="bold">
          応募状況
        </Text>
        <Text fz="md" fw="bold" ta="right">
          {applicationStatus?.currentCount || 0}/{applicationStatus?.limit || 0}
        </Text>
      </Stack>
      <Progress
        value={applicationProgress}
        color={getProgressColor(applicationProgress)}
        size="md"
        radius="md"
      />
      <Text c="dimmed" fz="xs" ta="center">
        あと
        {Math.max(
          0,
          (applicationStatus?.limit || 0) -
            (applicationStatus?.currentCount || 0),
        )}
        件まで応募可能
      </Text>
    </Stack>
  );
}

export function ApplicationStatusCard({
  isForceWithdown,
  applicationStatus,
}: Props) {
  return (
    <Card withBorder p="sm" radius="md">
      {isForceWithdown ? (
        <ForcedWithdrawnContent />
      ) : (
        <NormalContent applicationStatus={applicationStatus} />
      )}
    </Card>
  );
}
